import { CommonModule } from '@angular/common';
import { Directive, ElementRef, HostBinding, HostListener, Input, NgModule } from '@angular/core';
import { Browser } from '@capacitor/browser';

@Directive({
	standalone: false,
	selector: 'a[reachAnchor]',
})
export class ReachAnchorDirective {
	private _href = '';

	public routerLink?: string[];

	@HostBinding('attr.href')
	@Input()
	public set href(href: string) {
		const rawUrl = href;
		const hasProtocol = rawUrl.startsWith('http://') || rawUrl.startsWith('https://');
		const url = hasProtocol ? rawUrl : `https://${rawUrl}`;

		this._href = url;
	}

	public get href(): string {
		return this._href;
	}

	constructor(public elementRef: ElementRef<HTMLAnchorElement>) {}

	@HostListener('click', ['$event'])
	public onClick(event?: Event): void {
		if (!this.routerLink) {
			event?.preventDefault();
			Browser.open({ url: this.href });
		}
	}
}

@NgModule({
	declarations: [ReachAnchorDirective],
	imports: [CommonModule],
	exports: [ReachAnchorDirective],
})
export class ReachAnchorModule {}
